/**
 * Waritto 認証フック
 * 共通フックを使用（ゲスト対応）
 */
import { useNavigate } from "react-router-dom";
import { useAtom, useAtomValue } from "jotai";
import { useAuthCommon, type Participant } from "@tabipla/hooks/auth";
import {
  userAtom,
  participantAtom,
  isAuthenticatedAtom,
  isLoadingAtom,
  isAuthCheckedAtom,
} from "../atoms/auth-atoms";
import { signIn, signUp, signOut } from "@/infrastructure/auth/auth-client";
import { apiClient } from "@/infrastructure/api/client";

// Re-export Participant type for backward compatibility
export type { Participant };

export function useAuth() {
  const navigate = useNavigate();
  const [user, setUser] = useAtom(userAtom);
  const [participant, setParticipant] = useAtom(participantAtom);
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);
  const [isLoading, setIsLoading] = useAtom(isLoadingAtom);
  const [, setIsAuthChecked] = useAtom(isAuthCheckedAtom);

  const authActions = useAuthCommon({
    apiClient,
    authClient: { signIn, signUp, signOut },
    setUser,
    setIsLoading,
    setIsAuthChecked,
    navigate,
    guestSupport: { setParticipant },
  });

  return {
    user,
    participant,
    isAuthenticated,
    isLoading,
    isGuest: participant?.type === "guest",
    ...authActions,
  };
}
